import { Partnerships } from './partnerships'

export { Partnerships }
